module.exports = __webpack_public_path__ + "static/media/gh3plus.2d982333.jpg";